
export default function ServicesSection() {
  const loanProducts = [
    {
      title: 'Fix & Flip Loans',
      description: 'Short-term financing for property renovation and resale projects. We offer up to 100% purchase price and 100% rehab costs with competitive rates and fast closings.',
      icon: 'ri-hammer-line',
      features: ['Quick approval process', 'Up to 100% purchase + 100% rehab', 'Interest-only payments']
    },
    {
      title: 'DSCR Loans',
      description: 'Debt Service Coverage Ratio loans based on property cash flow rather than personal income verification.',
      icon: 'ri-line-chart-line',
      features: ['No income verification', 'Investment property focus', 'Flexible terms']
    },
    {
      title: 'Commercial Real Estate Loans',
      description: 'Financing for office buildings, retail spaces, warehouses, and other commercial properties.',
      icon: 'ri-building-2-line',
      features: ['Long-term financing', 'Competitive rates', 'Various property types']
    },
    {
      title: 'Bridge Loans',
      description: 'Short-term financing to bridge the gap between property purchase and permanent financing.',
      icon: 'ri-bridge-line',
      features: ['Fast closing', 'Flexible terms', 'Transition financing']
    },
    {
      title: 'Rental Property Loans',
      description: 'Financing for 1-4 unit and multifamily rental properties with investor-friendly terms.',
      icon: 'ri-home-4-line',
      features: ['1-4 units & multifamily', 'Investment property rates', 'Portfolio lending']
    },
    {
      title: 'Ground-Up Construction',
      description: 'Construction loans for new development projects from ground breaking to completion.',
      icon: 'ri-building-3-line',
      features: ['New construction', 'Draw schedule', 'Convert to permanent']
    },
    {
      title: 'Hard Money Loans',
      description: 'Asset-based lending with fast approval and funding for time-sensitive opportunities.',
      icon: 'ri-safe-line',
      features: ['Asset-based', 'Fast funding', 'Flexible requirements']
    },
    {
      title: 'Transactional Funding',
      description: 'Short-term funding for real estate assignments and double closings, typically 24-48 hours.',
      icon: 'ri-exchange-line',
      features: ['24-48 hour funding', 'Assignment deals', 'Double closings']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Comprehensive Loan Products
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We offer a wide range of lending products tailored to meet the unique needs of real estate investors and businesses. Our brokerage model means we shop multiple lenders to find you the best terms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {loanProducts.map((product, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${product.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {product.title}
              </h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                {product.description}
              </p>
              <ul className="space-y-2">
                {product.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-check-line text-green-500"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-blue-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Need a Custom Solution?
            </h3>
            <p className="text-gray-600 mb-6">
              Every deal is unique. Our experienced team can help structure custom financing solutions that match your specific project requirements and investment strategy.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Discuss Your Project
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
